import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';

import withModalView from 'components/ui/withModalView';
import withAuthorizer from 'components/ui/withAuthorizer';
import TemplateTypeSelect from 'components/ocr/TemplateTypeSelect';
import OCRTemplateApi from 'api/ocr-template';
import NotificationHelper from '@youfy/shared/helpers/NotificationHelper';
import SubmitButton from 'components/ui/buttons/SubmitButton';
import AWSHelper from 'helpers/AWSHelper';

import { Resources } from 'helpers/ResourceHelper';

const NewOCRTemplate = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const [saving, setSaving] = useState(false);
  const [type_id, setTypeID] = useState(null);

  const handleTypeChange = type => {
    console.log('type', type);
    setTypeID(type.value);
  };

  const saveFile = async (file, templateId) => {
    try {
      const name_splitted = file.name.split('.');
      const ext = name_splitted[name_splitted.length - 1];
      const Key = `${templateId}.${ext}`;

      await AWSHelper.upload2S3({
        Bucket: `ocr.youfy.com.br`,
        Key,
        Body: file,
      });

      await OCRTemplateApi.update(templateId, { status: 'PENDING' });
    } catch (error) {
      await OCRTemplateApi.delete(templateId);
      throw error;
    }
  };

  const onSubmit = async e => {
    e.preventDefault();

    try {
      setSaving(true);

      if (!type_id) {
        NotificationHelper.snack('Por favor, selecione um tipo de template');
        return;
      }

      const file = document.getElementById('inputFile').files[0];

      const data = {
        name: document.getElementById('inputName').value,
        type_id,
        file_attributes: { ...file, original_name: file.name },
      };

      const created_template = await OCRTemplateApi.create(data);
      await saveFile(file, created_template.id);
      NotificationHelper.snack('OCR Template criado com sucesso.');
      history.push(`/ocr/${created_template.id}/edit`);
    } catch (error) {
      console.log(error);

      if (error?.response?.status === 409) {
        NotificationHelper.snack('Já exite um template com este nome cadastrado.');
        return;
      }

      NotificationHelper.snack('Falha ao criar template.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div className="container">
        <div className="mb-2">{t('actions.add')}</div>
        <h3>{t('ocr.add.title')}</h3>
      </div>

      <div className="container mt-4">
        <form onSubmit={onSubmit}>
          <div className="row">
            <div className="col-md-12">
              <label htmlFor="inputName">Name</label>
              <input type="text" className="form-control" required name="name" id="inputName" placeholder="Template name" />
            </div>

            <div className="col-md-12 mt-3">
              <label htmlFor="inputName">Type</label>
              <TemplateTypeSelect onChange={handleTypeChange} />
            </div>

            <div className="col-md-12 mt-3">
              <label htmlFor="inputName">Demo file (pdf or jpg):</label>
              <input type="file" required accept=".pdf,.jpg" className="form-control" name="file" id="inputFile" />
            </div>

            <div className="col-md-12 mt-5">
              <hr />

              <SubmitButton loading={saving} className="btn btn-primary btn-lg">
                Criar
              </SubmitButton>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default withModalView(withAuthorizer(NewOCRTemplate, [Resources.DB_MANAGER]));
